import { gql } from '@apollo/client';

export interface ICreateHostGroupResponse {
  createHostGroup: { id: number; title: string; priority: number };
}
export const CREATE_HOST_GROUP = gql`
  mutation createGroup($input: HostGroupInput!) {
    createHostGroup(input: $input) {
      id
      title
      priority
    }
  }
`;

export interface IUpdateHostGroupResponse {
  updateHostGroup: { id: number; title: string; priority: number };
}
export const UPDATE_HOST_GROUP = gql`
  mutation updateGroup($id: Int!, $input: HostGroupInput!) {
    updateHostGroup(id: $id, input: $input) {
      id
      title
      priority
    }
  }
`;
